
function showDates() {
    
    const showMore = document.querySelector('.event-info-panel__show-more')
    const dateList = document.querySelector('.event-info-panel__event-dates')
    if(showMore != null) {
        showMore.onclick = function() {
            dateList.classList.toggle('active')
            if (showMore.innerHTML === 'More dates') {
                showMore.innerHTML = 'Less dates'
            } else {
                showMore.innerHTML = 'More dates'
            }
        }
    }
}

export default showDates
